import { render } from "./EntryLayout.vue?vue&type=template&id=fa886062"
import script from "./EntryLayout.vue?vue&type=script&lang=js"
export * from "./EntryLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__